import { render, staticRenderFns } from "./UploadsPageSkeletonLoader.vue?vue&type=template&id=4bc431f2&"
import script from "./UploadsPageSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./UploadsPageSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./UploadsPageSkeletonLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
